import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestFile = fp.get('guest.file');

export const getAll = createSelector(getGuestFile, fp.get('all'));

export const getAllValues = createSelector(getAll, fp.values);

export const getFetching = createSelector(getGuestFile, fp.get('fetching'));
export const getFetched = createSelector(getGuestFile, fp.get('fetched'));
export const getFetchingError = createSelector(
  getGuestFile,
  fp.get('fetchingError')
);

export const getSaving = createSelector(getGuestFile, fp.get('saving'));

export const getSaved = createSelector(getGuestFile, fp.get('saved'));

export const getSavingError = createSelector(
  getGuestFile,
  fp.get('savingError')
);

export const getDeleting = createSelector(getGuestFile, fp.get('deleting'));
export const getDeleted = createSelector(getGuestFile, fp.get('deleted'));
export const getDeletingError = createSelector(
  getGuestFile,
  fp.get('deletingError')
);

export const getOrder = createSelector(getGuestFile, fp.get('order'));
